module.exports = __webpack_public_path__ + "img/s-hd.d198f054.jpg";